<template>
  <b-card>
    <b-skeleton-wrapper :loading="renderLoading" class="animate__animated animate__fadeIn">
      <template #loading>
        <div class="content-header-card">
          <div class="content-header-img content-header-img-cos">
            <b-skeleton-img class="test" width="40px" height="40px" />
          </div>
          <div class="content-header-name w-50">
            <b-skeleton width="80%" class="skeleton-header" />
          </div>
        </div>
        <div class="content-body-card mt-1">
          <div class="d-flex justify-content-center flex-column">
            <b-skeleton width="70%" />
            <b-skeleton width="80%" />
            <b-skeleton width="50%" />
          </div>
        </div>
      </template>

      <div v-if="noItem">
        <card-no-item :textNoImg="'ไม่มีข้อมูล'" :height="100" />
      </div>
      <div v-else class="animate__animated animate__fadeIn">
        <div class="content-header-card">
          <div class="content-header-img">
            <img
              class="w-100"
              :src="$props.configCard.logo"
              alt=""
              draggable="false"
            />
          </div>
          <div class="content-header-name">
            <div>{{ $props.configCard.name }}</div>
          </div>
        </div>
        <div class="content-body-card">
          <div class="d-flex justify-content-center body-multi-card">
            <div
              class="w-100"
              v-for="(item, index) in renderData"
              :key="item.name + index"
              :class="index > 0 && 'multi-line-break'"
            >
              <div class="multi-overall-value">
                {{ formatter.format(item.value) }}
              </div>
              <div class="multi-overall-name">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BSkeletonWrapper,
  BSkeleton,
  BSkeletonImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import { onBeforeMount, ref, computed } from "@vue/composition-api";
import { formatter } from "@/utils/scripts/format-currency";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BSkeletonWrapper,
    BSkeleton,
    BSkeletonImg,
    CardNoItem,
    vSelect,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: [] },
  },
  setup(props) {
    const dataCard = ref([]);
    const isLoading = ref(false);
    const noItem = ref(false);

    const renderData = computed(() => {
      return props.dataBi.find((o) => {
        return o.id == props.configCard.id;
      })?.data;
    });

    const renderLoading = computed(() => {
      return props.dataBi.length == 0;
    });

    return {
      dataCard,
      isLoading,
      noItem,
      formatter,
      renderData,
      renderLoading
    };
  },
};
</script>

<style>
/* .content-header-img-cos .b-aspect-sizer {
background: red;
padding-bottom: 200% !important;
} */
</style>
